
<template>
    <div>
        <div v-if="plan">            
            <img :src="plan.banner" alt="" style="width: 100%;">

            <div style="padding:1rem .5rem;box-sizing: border-box;">
                <div class="flex">
                    <!-- <img :src="pro.logo" alt="" style="width: 1.2rem;height: auto;"> -->
                    <span style="font-size:.8rem;">{{plan.schemeName}}</span>
                </div>
                <div style="margin-top:.3rem;color:#7C8CAC;font-size:.5rem;line-height: .8rem;">
                    {{plan.schemeDescribe}}
                </div>
            </div>
        </div>
        
        <div class="part-tit">需求背景</div>
        <div class="cad-imgs">
            <img v-for="(item, index) in plan.background.split(',')" :key="index" v-lazy="item" alt="" class="img-box"/>
        </div>
        <div class="part-tit">方案架构</div>
        <div class="cad-imgs">
            <img v-lazy="plan.framework" alt="" class="img-box"/>
        </div>
        <div class="part-tit">方案优势</div>
        <div class="cad-imgs">
            <img v-for="(item, index) in plan.advantage.split(',')" :key="index" v-lazy="item" alt="" class="img-box"/>
        </div>
               
    </div>
</template>
<script>
export default {
    name:'plan', 
    data(){
        return{
            id:0, 
            plan: null,
            planArr:[],			
        }
    },
    created(){
        this.id = this.$route.query.id       
               
        this._get(this.API.planList+'?pageNo=1&pageSize=100').then((res) => {
            console.log(res)
            if (res.code == 200) {
                this.planArr = res.data.records;
                this.plan = this.planArr.find(item=>item.id==this.id)             
                    
                // this.detail.advantageTempArr = this.plan.advantage.split(",");
                // item.frameworkTempArr = item.framework.split(",");
                // item.backgroundTempArr = item.background.split(",");
                // this.detail = item;
                   
               
            }
        });
		
        
    },
    mounted(){},
    methods:{
        
    },
}
</script>
<style lang="less" scoped>
.ban-box{
    height: calc(100vw / (1920 / 440) );
    background-size: 100%;
    background-position: 100% 0% !important;
}
.part-tit{
    width: 100%;
    font-size: .7rem;
    text-align: center;
    padding: 1.5rem 0;
}
.cad-imgs{
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0 .5rem;

}
.img-box{
    width: 100%;
    margin-bottom: .85rem;
    max-width: 14rem;
    box-shadow: 0 1px 10px #e9e9e9;
}
</style>